module.exports = __webpack_public_path__ + "static/bebe-sucesso-agendamento-78711e96de8c17eebdcd705acb0a1cf9.png";